import { BaseService } from "./BaseService";
import { CommandService } from "./CommandService";
import { Configuration } from "Configuration";
import { MappingDisplayType } from "Enums";
import { MappingDefinition, GridDefinitionClient, BaseGridDefinition } from "./Client";

/**
 * Service for requesting gridDefinitions.
 * @hidden
 */
export class GridDefinitionService extends BaseService {
    /**
     * Get all gridDefinitions for a given mapping.
     * @param mappingName Name of the mapping.
     * @param displayType MappingDisplayType.
     */
    public getMapping(
        mappingName: string,
        displayType: MappingDisplayType = MappingDisplayType.FilterAndGrids
    ): Promise<MappingDefinition> {
        let param = CommandService.getContextParameters();
        let client = new GridDefinitionClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<MappingDefinition>((resolve, reject) => {
            client.getAll(mappingName, undefined, param, res => resolve(res), (exception, reason) => reject(exception));
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }

    /**
     * Get a single gridDefinition by gridId.
     * @param gridId GridID.
     */
    public getGrid(mappingName: string, gridId: number): Promise<BaseGridDefinition> {
        let param = CommandService.getRequestParameters();
        let client = new GridDefinitionClient(Configuration.baseUrl);
        client.beforeSend = this.getBeforeSend();
        return new Promise<BaseGridDefinition>((resolve, reject) => {
            client.getSingle(mappingName, gridId, param, res => resolve(res), (exception, reason) => reject(exception));
            // cancellationTokenSource.token.onCancelled((reason) => {
            //     xhr.abort();
            //     reject(reason);
            // });
        });
    }
}
